import React from 'react';
import TodoList from './components/TodoList';

const App: React.FC = () => {
  return <TodoList />;
};
export default App;
